import React from "react";
import { CashDepositCardWrapper, InsurerLogo } from "./styles";
import { Ptag } from "components/core";
import { formatDateYYYY, formatDecimalToCSV } from "utlis/utils";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import CashDepositImage from "assets/svgs/cash_deposit_design.svg";
import { IconButton } from "@mui/material";

function CashDepositCard({ cashDeposit }) {
  const {
    service_provider_name,
    service_provider_logo,
    last_updated_date,
    cd_balance_statement_url,
    balance_amount,
  } = cashDeposit;

  const openStatement = () => {
    window.open(cd_balance_statement_url, "_blank");
  };

  return (
    <CashDepositCardWrapper>
      <header>
        <div>
          <Ptag fontSize="16px" marginBottom="4px">
            {service_provider_name}
          </Ptag>
          {last_updated_date && (
            <Ptag color="#7D7C7C" fontWeight="400">
              as on {formatDateYYYY(last_updated_date)}
            </Ptag>
          )}
        </div>
        <InsurerLogo src={service_provider_logo} />
      </header>

      <footer>
        <Ptag fontWeight="700" fontSize="24px">
          Rs. {formatDecimalToCSV(balance_amount)}
        </Ptag>
        {cd_balance_statement_url && <IconButton onClick={openStatement}>
          <ArrowForwardIcon
            style={{
              fontSize: "24px",
            }}
          />
        </IconButton>}
      </footer>
      <img src={CashDepositImage} alt="" />
    </CashDepositCardWrapper>
  );
}

export default CashDepositCard;
